import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {wwData$} from '@px/streams/worker-data';
import Msg = ww.Msg;
import ContractConditionalOrderData = ww.ContractConditionalOrderData;

export const conditionalOrders$ = new BehaviorSubject<ContractConditionalOrder[]>([]);

wwData$
  .pipe(
    filter((o: Msg<ContractConditionalOrderData>) => o.type === 'contract-orders-conditional'),
    map((o: Msg<ContractConditionalOrderData>) => o.data.orders)
  )
  .subscribe((orders) => conditionalOrders$.next(orders));
